<template>
    <div>
        <v-container grid-list-xs>
            <div>
                <div class="pa-0">
                    <v-card class="pa-0">
                        <v-card-actions class="pa-0">
                            <BackButton id="pdf-view-back-btn-1" class="mx-4 mt-4" />
                        </v-card-actions>
                        <PDFViewer v-if="pdfUrl" :pdf-url="pdfUrl" />
                    </v-card>
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
    import PDFViewer from "@/components/terms/PDFViewer.vue"
    import { appendWebSessionId } from "@/util/url"

    export default {
        components: { PDFViewer },
        data() {
            return {
                pdfUrl: "",
            }
        },
        mounted() {
            const { pdfUrl } = this.$route.params
            this.pdfUrl = appendWebSessionId(
                `${window.location.protocol}//${window.location.host}/api/v1/proxy?url=${encodeURI(pdfUrl)}`
            )
        },
    }
</script>

<style lang="scss" scoped>
    #pdf-canvas {
        width: 100%;
        border: 0;
    }

    .loading-wrapper {
        height: 329px;
        margin-top: 130px;
    }
</style>
